<div class="wrapper">
  <h4 class="inter h4 w700">{{ 'app.footer.operator' | i18n }}:</h4>
  <div class="logo">
    <img alt="datafriends.cz" src="assets/img/datafriends.png" />
  </div>
  <p class="inter large w500 meta">
    DataFriends s.r.o.
    <br><br>
    Pernerova 676/51, 186 00 Praha 8
    <br><br>
    IČ: 05689651
    <br>
    DIČ: CZ05689651
  </p>
  <p class="inter small">© 2026 DataFriends. {{ 'app.footer.rights' | i18n }}</p>
</div>
